import { render, staticRenderFns } from "./orderHeader.vue?vue&type=template&id=3d98bdde&scoped=true"
import script from "./orderHeader.vue?vue&type=script&lang=js"
export * from "./orderHeader.vue?vue&type=script&lang=js"
import style0 from "./orderHeader.vue?vue&type=style&index=0&id=3d98bdde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98bdde",
  null
  
)

export default component.exports